
import { defineComponent } from 'vue'
import { iMeasure, iRule } from '../../MeasureDefinition'
import AutoComplete from 'primevue/autocomplete'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dropdown from 'primevue/dropdown'
import metadataCardDescriptor from './MeasureDefinitionMetadataCardDescriptor.json'

export default defineComponent({
    name: 'measure-definition-metadata-card',
    components: { AutoComplete, Column, Dropdown, DataTable },
    props: {
        currentRule: {
            type: Object,
            required: true
        },
        tipologiesType: {
            type: Array,
            required: true
        },
        domainsTemporalLevel: {
            type: Array
        },
        categories: {
            type: Array,
            required: true
        }
    },
    emits: ['touched'],
    data() {
        return {
            metadataCardDescriptor,
            rule: {
                ruleOutputs: [] as iMeasure[]
            } as iRule,
            filteredCategories: [] as any[],
            metadataError: null
        }
    },
    async mounted() {
        this.loadRule()
    },
    methods: {
        loadRule() {
            this.rule = this.currentRule as iRule
        },
        searchCategories(event) {
            setTimeout(() => {
                if (!event.query.trim().length) {
                    this.filteredCategories = [...this.categories] as any[]
                } else {
                    this.filteredCategories = this.categories.filter((category: any) => {
                        return category.valueCd.toLowerCase().startsWith(event.query.toLowerCase())
                    })
                }
            }, 250)
        },
        alisIconTooltip(iconClass: string) {
            if (iconClass.includes('icon-used')) {
                return this.$t('kpi.measureDefinition.aliasUsed')
            } else if (iconClass.includes('icon-missing')) {
                return this.$t('kpi.measureDefinition.aliasMissing')
            }
        },
        setRuleCategory(category: any, alias: any) {
            alias.category.valueCd = category.valueCd
        }
    }
})
